import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider as StoreProvider } from "react-redux";
import { FirebaseProvider, MixpanelProvider } from "./context";
import { store } from "@store";
import { switchToComposeMode } from "@store/global";
import App from "./App";
import "./index.scss";

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : null;

Office.onReady((info) => {
  if (info.host !== Office.HostType.Outlook) {
    return;
  }

  if (Office.context.mailbox?.item?.getItemIdAsync) {
    store.dispatch(switchToComposeMode());
  }

  root?.render(
    <StrictMode>
      <StoreProvider store={store}>
        <FirebaseProvider>
          <MixpanelProvider>
            <App />
          </MixpanelProvider>
        </FirebaseProvider>
      </StoreProvider>
    </StrictMode>
  );
});
